import { Button, FormField, FormInput, FormTextarea, Modal, ModalBody, ModalFooter, ModalHeader } from '@/_components';
import { FormCurrencyInput, FormInputUrl, FormLayout } from '@/_containers';
import type { VendorDetailsFormSchema } from '@/_pages/settings/inventory-kits/shared/schemas/vendor-details';

import { useInventoryFormContext } from '../../form-context';

type EditVendorDetailModalProps = {
  vendorDetail: VendorDetailsFormSchema;
  index: number;
  open: boolean;
  onClose: () => void;
};

export function EditVendorDetailModal({ vendorDetail, index, onClose, open }: EditVendorDetailModalProps) {
  const form = useInventoryFormContext();

  return (
    <Modal open={open} size="lg" onClose={onClose} disableBackdropClosing>
      <ModalHeader>{vendorDetail.vendor.name}</ModalHeader>
      <ModalBody>
        <FormField
          control={form.control}
          key={vendorDetail.id}
          name={`vendor_details.${index}`}
          render={() => (
            <FormLayout className="mt-8">
              <FormField
                control={form.control}
                name={`vendor_details.${index}.vendor_sku`}
                render={({ field }) => (
                  <FormInput formItemClassName="col-span-12 sm:col-span-3" label="SKU" {...field} />
                )}
              />
              <FormField
                control={form.control}
                name={`vendor_details.${index}.vendor_url`}
                render={({ field }) => (
                  <FormInputUrl label="URL" formItemClassName="col-span-12 sm:col-span-6" {...field} />
                )}
              />

              <FormCurrencyInput
                name={`vendor_details.${index}.last_price`}
                label="Last Price"
                formItemClassName="col-span-12 sm:col-span-3"
                isEditable
              />

              <FormField
                control={form.control}
                name={`vendor_details.${index}.vendor_note`}
                render={({ field }) => <FormTextarea formItemClassName="col-span-12" label="Notes" {...field} />}
              />
            </FormLayout>
          )}
        />
      </ModalBody>
      <ModalFooter className="mt-6">
        <Button
          modal
          as="outline"
          onClick={() => {
            form.resetField(`vendor_details.${index}`);
            onClose();
          }}
        >
          Cancel
        </Button>
        <Button modal onClick={onClose}>
          Done
        </Button>
      </ModalFooter>
    </Modal>
  );
}
